<script setup lang="ts">
import { RouterLink } from 'vue-router';
import { TELEGRAM_BOT_URL } from '@app/presentation/components/site/constants';
import BrandLogo from '@app/presentation/components/shared/BrandLogo.vue';
import PaperStrip from '@app/presentation/components/paper/PaperStrip.vue';
</script>

<template>
  <!-- Paper strip with a torn top edge (PaperStrip: card stock, lit fibre,
       cast shade onto the page above); pencil (dashed) separators inside. -->
  <footer class="relative isolate py-12 md:py-16">
    <PaperStrip edge="top" wide />
    <div class="site-container">
      <div class="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
        <div>
          <BrandLogo />
          <p class="mt-3 max-w-[280px] text-sm leading-relaxed text-muted-foreground">
            Расклады на картах Таро с тёплым котом-проводником. tarotmeow.ru
          </p>
        </div>

        <div class="flex flex-wrap gap-x-12 gap-y-8 sm:gap-16">
          <div class="flex flex-col gap-2.5 text-sm">
            <div class="mb-1 font-semibold text-foreground">Продукт</div>
            <RouterLink to="/rasklady" class="text-muted-foreground transition-colors hover:text-foreground">Расклады</RouterLink>
            <RouterLink to="/karty" class="text-muted-foreground transition-colors hover:text-foreground">Значение карт</RouterLink>
            <RouterLink to="/ceny" class="text-muted-foreground transition-colors hover:text-foreground">Цены</RouterLink>
            <RouterLink to="/faq" class="text-muted-foreground transition-colors hover:text-foreground">FAQ</RouterLink>
          </div>

          <div class="flex flex-col gap-2.5 text-sm">
            <div class="mb-1 font-semibold text-foreground">Ещё</div>
            <a
              :href="TELEGRAM_BOT_URL"
              target="_blank"
              rel="noopener"
              class="text-muted-foreground transition-colors hover:text-foreground"
            >
              Telegram бот
            </a>
          </div>
        </div>
      </div>

      <div class="mt-10 border-t border-dashed border-foreground/20 pt-6 text-[13px] text-muted-foreground">© 2026 Таро Мяу · Сделано с 🐾</div>
    </div>
  </footer>
</template>
